import { HubConnection } from '@microsoft/signalr';
import { debounce } from 'lodash';

import { SignalRDefaultDebounceOptions, SignalRDefaultDebounceTimeout } from '../../../../Config';
import { store } from '../../../../shared/store';
import { fetchAmcDashboard } from '../amc-slice';

// App-lifetime listener (registered once alongside the other feature hub listeners in
// shared/hubs/index.ts), scoped by a runtime check: only refetch once the AMC page has loaded
// a dashboard AND the event is for the displayed year — the period selector is component-local,
// so refetching another year's event would silently swap the grid under the admin's selection.
export const initQualityReportingHubConnection = (connection: HubConnection) => {
    connection.on(
        'CqmAutoCalcCompleted',
        debounce(
            (payload: { year: number }) => {
                const { amc } = store.getState();
                if (!amc?.dashboard || payload.year !== amc.dashboard.year) return;
                // The broadcast reports a native recompute. Under an import scope it says nothing
                // about the numbers on screen, so leave them alone rather than refetching them away.
                if (amc.dashboard.importRunId) return;
                store.dispatch(fetchAmcDashboard({ year: payload.year }) as any);
            },
            SignalRDefaultDebounceTimeout,
            SignalRDefaultDebounceOptions
        )
    );
};
